export { OpenPdfDirective } from '../../../../core/directives/open-pdf.directive';
